import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import WhatIsAuraXR from "@/components/WhatIsAuraXR";
import Experience from "@/components/Experience";
import Journey from "@/components/Journey";
import Devices from "@/components/Devices";
import ForTeachers from "@/components/ForTeachers";
import ForStudents from "@/components/ForStudents";
import ForParents from "@/components/ForParents";
import Perspectives from "@/components/Perspectives";
import FutureClassroom from "@/components/FutureClassroom";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#050811] text-slate-100">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <WhatIsAuraXR />
        <Experience />
        <Journey />
        <Devices />
        <ForTeachers />
        <ForStudents />
        <ForParents />
        <Perspectives />
        <FutureClassroom />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
